import clsx from 'clsx';
import { DetailedHTMLProps, forwardRef, HTMLAttributes } from 'react';

export type IconProps = DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & {
    className?: string;
    icon: string;
};

const Icon = forwardRef<HTMLSpanElement, IconProps>(
    ({ icon, className = '', ...restProps }, ref) => {
        const displayedIcon = icon === 'tiktok_business' ? 'tiktok' : icon;
        return <i ref={ref} className={clsx(`icon-${displayedIcon}`, className)} {...restProps} />;
    }
);

Icon.displayName = 'Icon';

export default Icon;
